import type { AppDispatch, RootState } from '@/shared/store'
import type { LocalLayer } from '../../layer/types'
import { addCurrent } from '../../layer/layerSlice'
import { decrementTempId } from '../editorSyncSlice'

/**
 * Add a new layer to a slide with a temp ID.
 * Assigns the next temp ID (negative, decrementing) and dispatches to the layer adapter.
 */
export const addLayer = (
  payload: { slideId: number; layer: LocalLayer },
) => (dispatch: AppDispatch, getState: () => RootState) => {
  const { slideId, layer } = payload
  const { nextTempId } = getState().editor.sync

  const newLayer: LocalLayer = {
    ...layer,
    id: nextTempId,
    slideId,
  }

  dispatch(addCurrent(newLayer))
  dispatch(decrementTempId())
}
